import React from 'react';
import { ServiceType, Urgency } from '../../api/marketplace';
import { SERVICE_LABELS, SERVICE_TYPES, URGENCIES, URGENCY_LABELS } from './marketplaceFormat';

// Editable request fields shared by the admin detail page and the "Create
// marketplace request" dialog on a support ticket. Countries are edited as a
// comma-separated string and parsed on save.
export interface RequestFieldValues {
  serviceType: ServiceType;
  countries: string;
  language: string;
  urgency: Urgency;
  anonymisedSummary: string;
  userId: string;
  customerEmail: string;
  customerName: string;
}

interface RequestFieldsProps {
  values: RequestFieldValues;
  onChange: (values: RequestFieldValues) => void;
  disabled?: boolean;
  showCustomer?: boolean;
}

const RequestFields: React.FC<RequestFieldsProps> = ({ values, onChange, disabled, showCustomer = true }) => {
  const set = <K extends keyof RequestFieldValues>(key: K, value: RequestFieldValues[K]) =>
    onChange({ ...values, [key]: value });

  return (
    <fieldset className="marketplace-fieldset" disabled={disabled}>
      <div className="marketplace-form-row">
        <label>
          Service
          <select value={values.serviceType} onChange={e => set('serviceType', e.target.value as ServiceType)}>
            {SERVICE_TYPES.map(type => (
              <option key={type} value={type}>{SERVICE_LABELS[type]}</option>
            ))}
          </select>
        </label>
        <label>
          Countries (ISO codes)
          <input
            type="text"
            value={values.countries}
            onChange={e => set('countries', e.target.value)}
            placeholder="PT, BR"
          />
        </label>
        <label>
          Language (ISO code)
          <input
            type="text"
            value={values.language}
            onChange={e => set('language', e.target.value)}
            placeholder="en"
            maxLength={5}
          />
        </label>
        <label>
          Urgency
          <select value={values.urgency} onChange={e => set('urgency', e.target.value as Urgency)}>
            {URGENCIES.map(level => (
              <option key={level} value={level}>{URGENCY_LABELS[level]}</option>
            ))}
          </select>
        </label>
      </div>
      <label>
        Anonymised summary (English, shown to partners)
        <textarea
          value={values.anonymisedSummary}
          onChange={e => set('anonymisedSummary', e.target.value)}
          rows={5}
          placeholder="No names, emails, phone numbers, ID numbers or addresses."
        />
      </label>
      {showCustomer && (
        <div className="marketplace-form-row">
          <label>
            User ID
            <input type="text" value={values.userId} onChange={e => set('userId', e.target.value)} />
          </label>
          <label>
            Customer email
            <input
              type="email"
              value={values.customerEmail}
              onChange={e => set('customerEmail', e.target.value)}
            />
          </label>
          <label>
            Customer name
            <input
              type="text"
              value={values.customerName}
              onChange={e => set('customerName', e.target.value)}
            />
          </label>
        </div>
      )}
    </fieldset>
  );
};

export default RequestFields;
